var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 60,
    viewBox: "0 0 83 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5949 0C51.4403 0 43.2128 2.02836 41.3964 5.91603H41.0069C40.771 5.40714 40.4247 4.93059 39.9817 4.48687V5.91603V7.12041V7.55106V46.0962V47.4486V48.1891V49.5264H82.4034V7.55106H80.9569H78.1791C78.1772 2.59348 68.8271 0 59.5949 0ZM76.8291 46.0963H42.4235V7.55119V7.12054C43.0397 3.89899 50.4817 1.3524 59.5949 1.3524C69.1098 1.3524 76.8262 4.1275 76.8291 7.55119V46.0963Z",
    fill: "#616E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8086 1.35228C26.4945 1.35228 29.9023 1.77273 32.7036 2.48103V1.07949C29.716 0.36746 26.2576 0 22.8086 0C13.5754 0 4.22627 2.59336 4.22341 7.55019V7.55106H1.44657H0V49.5264H32.7036V48.1891V47.4486V46.0962H5.57718V7.55106C5.58005 4.12738 13.2936 1.35228 22.8086 1.35228Z",
    fill: "#616E7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7035 12.9613V7.55132V2.48129C29.9023 1.77299 26.4944 1.35254 22.8085 1.35254C13.2937 1.35254 5.58001 4.12764 5.57715 7.55132V46.0964H32.7035V34.3752H8.84174V31.6995H32.7034V25.0064H8.84174V22.3302H32.7034V15.6365H8.84174V12.9613H32.7035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4233 7.12067V7.55132V46.0964H76.8289V7.55132C76.8261 4.12764 69.1097 1.35254 59.5947 1.35254C50.4814 1.35254 43.0393 3.89913 42.4233 7.12067ZM73.5614 34.3752H46.0896V31.6995H73.5614V34.3752ZM73.5614 25.0065H46.0896V22.3303H73.5614V25.0065ZM73.5614 15.6365H46.0896V12.9613H73.5614V15.6365Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7035 12.9609H8.8418V15.6361H32.7035V12.9609Z",
    fill: "#82BFAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7035 22.3301H8.8418V25.0063H32.7035V22.3301Z",
    fill: "#82BFAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7035 31.6992H8.8418V34.3749H32.7035V31.6992Z",
    fill: "#82BFAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5614 12.9609H46.0896V15.6361H73.5614V12.9609Z",
    fill: "#82BFAB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5614 22.3301H46.0896V25.0063H73.5614V22.3301Z",
    fill: "#82BFAB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5614 31.6992H46.0896V34.3749H73.5614V31.6992Z",
    fill: "#82BFAB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7036 7.55068V12.9607V15.6359V22.3295V25.0057V31.6988V34.3745V46.0956V47.4481V48.1886V49.5259V59.9995L36.3138 56.3637L39.9819 59.9995V49.5259V48.1886V47.4481V46.0956V7.55068V7.12003V5.91565V4.48649C38.4709 2.97026 35.8559 1.82994 32.7037 1.0791V2.48064V7.55068H32.7036Z",
    fill: "#D31C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.3c216628ecec12942df772dfa184d2bb.svg";
export { ForwardRef as ReactComponent };